import React, {useState, useContext, useEffect} from "react";

const fullscreenActivationContext = React.createContext();
const fullscreenToggleContext = React.createContext();

export function getFullscreenActivationContext() {
    return useContext(fullscreenActivationContext);
}
export function getFullscreenToggleContext() {
    // console.log("aaaa")
    return useContext(fullscreenToggleContext);
}

const FullScreenProvider = ({ children }) =>{

    const [fullscreenActivation, setFullscreenActivation] = useState(false);

    useEffect(() => {
        const handleChange = () => {
            const isFullscreen = !!(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            );
            setFullscreenActivation(isFullscreen);
        };

        document.addEventListener("fullscreenchange", handleChange);
        document.addEventListener("webkitfullscreenchange", handleChange);
        document.addEventListener("mozfullscreenchange", handleChange);
        document.addEventListener("MSFullscreenChange", handleChange);

        return () => {
            document.removeEventListener("fullscreenchange", handleChange);
            document.removeEventListener("webkitfullscreenchange", handleChange);
            document.removeEventListener("mozfullscreenchange", handleChange);
            document.removeEventListener("MSFullscreenChange", handleChange);
        };
    }, []);

    const cambiaFullscreen = () => {
        if(fullscreenActivation){
            closeFullscreen()
        }else{
            openFullscreen()
        }
    }

    return (
        <fullscreenActivationContext.Provider value={fullscreenActivation}>
            <fullscreenToggleContext.Provider value={cambiaFullscreen}>
                { children }
            </fullscreenToggleContext.Provider>
        </fullscreenActivationContext.Provider>
    );
}



var elem = document.documentElement;
function openFullscreen() {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
        document.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
    }
}

function closeFullscreen() {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
    }
}


function fs_status() {
    var fullScreenElement = window.fullscreenElement || window.webkitFullscreenElement || window.mozFullScreenElement || window.msFullscreenElement
    return fullScreenElement;
}



export default FullScreenProvider;